var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuotaSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.6471C15.7443 13.8695 15.02 13.3475 14.1997 13.3475H12.1971C11.3768 13.3475 10.6631 13.8695 10.3968 14.6471L9.88549 15.9787H16.5113L16 14.6471Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1984 11.4088C14.2956 11.4088 15.1904 10.514 15.1904 9.41678C15.1904 8.31957 14.2956 7.42477 13.1984 7.42477C12.1012 7.42477 11.2064 8.31957 11.2064 9.41678C11.2064 10.514 12.1012 11.4088 13.1984 11.4088Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40479 4.74035H6.62583V11.249H8.40479V4.74035Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57124 7.58455H3.79228V11.249H5.57124V7.58455Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8735 15.8509L9.38482 14.3063C9.78961 13.1025 10.9081 12.2929 12.1758 12.2823C10.9933 11.8562 10.1411 10.7377 10.1411 9.41678C10.1411 7.73369 11.5153 6.35952 13.1984 6.35952C14.4341 6.35952 15.4993 7.10519 15.9787 8.15979V2.50333C15.9787 1.55526 15.9787 1.04394 15.8296 0.745672C15.7017 0.490013 15.4887 0.276964 15.233 0.149134C14.9454 0 14.4234 0 13.4754 0H2.49268C1.55526 0.0106525 1.03329 0.0106525 0.745672 0.159787C0.490013 0.287617 0.276964 0.500666 0.149134 0.756325C0 1.04394 0 1.56591 0 2.51398V13.4967C0 14.4447 0 14.9561 0.149134 15.2543C0.276964 15.51 0.490013 15.723 0.745672 15.8509C1.03329 16 1.55526 16 2.50333 16H8.83089L8.8735 15.8615V15.8509ZM2.72703 11.7816V7.05193C2.72703 6.75366 2.96138 6.51931 3.25965 6.51931H5.57124V4.20772C5.57124 3.90945 5.80559 3.6751 6.10386 3.6751H8.94807C9.24634 3.6751 9.48069 3.90945 9.48069 4.20772V11.7816C9.48069 12.0799 9.24634 12.3142 8.94807 12.3142H3.25965C2.96138 12.3142 2.72703 12.0799 2.72703 11.7816Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuotaSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/quotaSelected.6e8cb357452666a25ad024b68e7c8665.svg";